(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 82254:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(34155);

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isNetlify = exports.isVercel = void 0;
var generic_1 = __importDefault(__webpack_require__(48271));
var vercel_1 = __importDefault(__webpack_require__(74243));
var netlify_1 = __importDefault(__webpack_require__(23679));
exports.isVercel = process.env.AXIOM_INGEST_ENDPOINT || process.env.NEXT_PUBLIC_AXIOM_INGEST_ENDPOINT;
exports.isNetlify = process.env.NETLIFY == 'true';
// Detect the platform provider, and return the appropriate config
// fallback to generic config if no provider is detected
var config = new generic_1.default();
if (exports.isVercel) {
    config = new vercel_1.default();
}
else if (exports.isNetlify) {
    config = new netlify_1.default();
}
exports["default"] = config;
//# sourceMappingURL=config.js.map

/***/ }),

/***/ 42029:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
__webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = exports.U9 = void 0;
var webVitals_1 = __webpack_require__(20921);
Object.defineProperty(exports, "U9", ({ enumerable: true, get: function () { return webVitals_1.reportWebVitals; } }));
var logger_1 = __webpack_require__(55709);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return logger_1.log; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return logger_1.Logger; } });
var withAxiom_1 = __webpack_require__(42726);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return withAxiom_1.withAxiom; } });
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 55709:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(34155);

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.prettyPrint = exports.log = exports.Logger = exports.LogLevel = void 0;
var config_1 = __importStar(__webpack_require__(82254));
var shared_1 = __webpack_require__(19690);
var url = config_1.default.getLogsEndpoint();
var LOG_LEVEL = process.env.AXIOM_LOG_LEVEL || 'debug';
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["debug"] = 0] = "debug";
    LogLevel[LogLevel["info"] = 1] = "info";
    LogLevel[LogLevel["warn"] = 2] = "warn";
    LogLevel[LogLevel["error"] = 3] = "error";
    LogLevel[LogLevel["off"] = 100] = "off";
})(LogLevel = exports.LogLevel || (exports.LogLevel = {}));
var Logger = /** @class */ (function () {
    function Logger(args, req, autoFlush, source, logLevel) {
        if (args === void 0) { args = {}; }
        if (req === void 0) { req = null; }
        if (autoFlush === void 0) { autoFlush = true; }
        if (source === void 0) { source = 'frontend'; }
        var _this = this;
        this.args = args;
        this.req = req;
        this.autoFlush = autoFlush;
        this.source = source;
        this.logEvents = [];
        this.throttledSendLogs = (0, shared_1.throttle)(this.sendLogs, 1000);
        this.children = [];
        this.debug = function (message, args) {
            if (args === void 0) { args = {}; }
            _this._log('debug', message, args);
        };
        this.info = function (message, args) {
            if (args === void 0) { args = {}; }
            _this._log('info', message, args);
        };
        this.warn = function (message, args) {
            if (args === void 0) { args = {}; }
            _this._log('warn', message, args);
        };
        this.error = function (message, args) {
            if (args === void 0) { args = {}; }
            _this._log('error', message, args);
        };
        this.with = function (args) {
            var child = new Logger(__assign(__assign({}, _this.args), args), _this.req, _this.autoFlush, _this.source);
            _this.children.push(child);
            return child;
        };
        this.withRequest = function (req) {
            return new Logger(__assign({}, _this.args), req, _this.autoFlush, _this.source);
        };
        this._log = function (level, message, args) {
            if (args === void 0) { args = {}; }
            if (LogLevel[level] < LogLevel[_this.logLevel]) {
                return;
            }
            var logEvent = { level: level, message: message, _time: new Date(Date.now()).toISOString(), fields: _this.args || {} };
            // check if passed args is an object, if its not an object, add it to fields.args
            if (typeof args === 'object' && args !== null && Object.keys(args).length > 0) {
                logEvent.fields = __assign(__assign({}, logEvent.fields), args);
            }
            else if (args && args.length) {
                logEvent.fields = __assign(__assign({}, logEvent.fields), { args: args });
            }
            config_1.default.injectPlatformMetadata(logEvent, _this.source);
            if (_this.req != null) {
                logEvent.request = _this.req;
                if (logEvent.platform) {
                    logEvent.platform.route = _this.req.path;
                }
                else if (logEvent.vercel) {
                    logEvent.vercel.route = _this.req.path;
                }
            }
            _this.logEvents.push(logEvent);
            if (_this.autoFlush) {
                _this.throttledSendLogs();
            }
        };
        this.attachResponseStatus = function (statusCode) {
            _this.logEvents = _this.logEvents.map(function (log) {
                if (log.request) {
                    log.request.statusCode = statusCode;
                }
                return log;
            });
        };
        this.flush = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(__spreadArray([this.sendLogs()], this.children.map(function (c) { return c.flush(); }), true))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        this.logLevel = logLevel || LOG_LEVEL || 'debug';
    }
    Logger.prototype.sendLogs = function () {
        return __awaiter(this, void 0, void 0, function () {
            var method, keepalive, body, headers, reqOptions, fetch_1, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.logEvents.length) {
                            return [2 /*return*/];
                        }
                        if (!config_1.default.isEnvVarsSet()) {
                            // if AXIOM ingesting url is not set, fallback to printing to console
                            // to avoid network errors in development environments
                            this.logEvents.forEach(function (ev) { return prettyPrint(ev); });
                            this.logEvents = [];
                            return [2 /*return*/];
                        }
                        method = 'POST';
                        keepalive = true;
                        body = JSON.stringify(this.logEvents);
                        // clear pending logs
                        this.logEvents = [];
                        headers = {
                            'content-type': 'application/json',
                        };
                        if (config_1.default.token) {
                            headers['Authorization'] = "Bearer ".concat(config_1.default.token);
                        }
                        reqOptions = { body: body, method: method, keepalive: keepalive, headers: headers };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 8, , 9]);
                        if (!(typeof fetch === 'undefined')) return [3 /*break*/, 4];
                        return [4 /*yield*/, __webpack_require__(66477)];
                    case 2:
                        fetch_1 = _a.sent();
                        return [4 /*yield*/, fetch_1(url, reqOptions)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 7];
                    case 4:
                        if (!(config_1.default.isBrowser && config_1.isVercel && navigator.sendBeacon)) return [3 /*break*/, 5];
                        navigator.sendBeacon(url, body);
                        return [3 /*break*/, 7];
                    case 5: return [4 /*yield*/, fetch(url, reqOptions)];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        e_1 = _a.sent();
                        console.error("Failed to send logs to Axiom: ".concat(e_1));
                        return [3 /*break*/, 9];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    return Logger;
}());
exports.Logger = Logger;
exports.log = new Logger();
var levelColors = {
    info: {
        terminal: '32',
        browser: 'lightgreen',
    },
    debug: {
        terminal: '36',
        browser: 'lightblue',
    },
    warn: {
        terminal: '33',
        browser: 'yellow',
    },
    error: {
        terminal: '31',
        browser: 'red',
    },
};
function prettyPrint(ev) {
    var hasFields = Object.keys(ev.fields).length > 0;
    // check whether pretty print is disabled
    if (shared_1.isNoPrettyPrint) {
        var msg = "".concat(ev.level, " - ").concat(ev.message);
        if (hasFields) {
            msg += ' ' + JSON.stringify(ev.fields);
        }
        console.log(msg);
        return;
    }
    // print indented message, instead of [object]
    // We use the %o modifier instead of JSON.stringify because stringify will print the
    // object as normal text, it loses all the functionality the browser gives for viewing
    // objects in the console, such as expanding and collapsing the object.
    var msgString = '';
    var args = [ev.level, ev.message];
    if (config_1.default.isBrowser) {
        msgString = '%c%s - %s';
        args = __spreadArray(["color: ".concat(levelColors[ev.level].browser, ";")], args, true);
    }
    else {
        msgString = "\u001B[".concat(levelColors[ev.level].terminal, "m%s\u001B[0m - %s");
    }
    // we check if the fields object is not empty, otherwise its printed as <empty string>
    // or just "".
    if (hasFields) {
        msgString += ' %o';
        args.push(ev.fields);
    }
    if (ev.request) {
        msgString += ' %o';
        args.push(ev.request);
    }
    console.log.apply(console, __spreadArray([msgString], args, true));
}
exports.prettyPrint = prettyPrint;
//# sourceMappingURL=logger.js.map

/***/ }),

/***/ 48271:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(34155);

Object.defineProperty(exports, "__esModule", ({ value: true }));
var shared_1 = __webpack_require__(19690);
// This is the generic config class for all platforms that doesn't have a special
// implementation (e.g: vercel, netlify). All config classes extends this one.
var GenericConfig = /** @class */ (function () {
    function GenericConfig() {
        this.proxyPath = '/_axiom';
        this.isBrowser = typeof window !== 'undefined';
        this.shoudSendEdgeReport = false;
        this.token = process.env.AXIOM_TOKEN;
        this.dataset = process.env.AXIOM_DATASET;
        this.environment = "production";
        this.axiomUrl = process.env.AXIOM_URL || 'https://cloud.axiom.co';
        this.region = process.env.REGION || undefined;
    }
    GenericConfig.prototype.isEnvVarsSet = function () {
        return !!(this.axiomUrl && process.env.AXIOM_DATASET && process.env.AXIOM_TOKEN);
    };
    GenericConfig.prototype.getIngestURL = function (_) {
        return "".concat(this.axiomUrl, "/api/v1/datasets/").concat(this.dataset, "/ingest");
    };
    GenericConfig.prototype.getLogsEndpoint = function () {
        return this.isBrowser ? "".concat(this.proxyPath, "/logs") : this.getIngestURL(shared_1.EndpointType.logs);
    };
    GenericConfig.prototype.getWebVitalsEndpoint = function () {
        return this.isBrowser ? "".concat(this.proxyPath, "/logs") : this.getIngestURL(shared_1.EndpointType.webVitals);
    };
    GenericConfig.prototype.wrapWebVitalsObject = function (metrics) {
        var _this = this;
        return metrics.map(function (m) { return ({
            webVital: m,
            _time: new Date().getTime(),
            platform: {
                environment: _this.environment,
                source: 'web-vital',
            },
        }); });
    };
    GenericConfig.prototype.injectPlatformMetadata = function (logEvent, source) {
        logEvent.platform = {
            environment: this.environment,
            region: this.region,
            source: source + '-log',
        };
    };
    GenericConfig.prototype.generateRequestMeta = function (req) {
        return {
            startTime: new Date().getTime(),
            path: req.url,
            method: req.method,
            host: this.getHeaderOrDefault(req, 'host', ''),
            userAgent: this.getHeaderOrDefault(req, 'user-agent', ''),
            scheme: 'https',
            ip: this.getHeaderOrDefault(req, 'x-forwarded-for', ''),
            region: this.region,
        };
    };
    GenericConfig.prototype.getHeaderOrDefault = function (req, headerName, defaultValue) {
        return req.headers[headerName] ? req.headers[headerName] : defaultValue;
    };
    return GenericConfig;
}());
exports["default"] = GenericConfig;
//# sourceMappingURL=generic.js.map

/***/ }),

/***/ 23679:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(34155);

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var generic_1 = __importDefault(__webpack_require__(48271));
var netlifySiteId = process.env.SITE_ID;
var netlifyBuildId = process.env.BUILD_ID;
var netlifyContext = process.env.CONTEXT;
var netlifyDeploymentUrl = process.env.DEPLOYMENT_URL;
var netlifyDeploymentId = process.env.DEPLOYMENT_ID;
var NetlifyConfig = /** @class */ (function (_super) {
    __extends(NetlifyConfig, _super);
    function NetlifyConfig() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NetlifyConfig.prototype.wrapWebVitalsObject = function (metrics) {
        var _this = this;
        return metrics.map(function (m) { return ({
            webVital: m,
            _time: new Date().getTime(),
            netlify: {
                environment: _this.environment,
                source: 'web-vital',
                siteId: netlifySiteId,
                buildId: netlifyBuildId,
                context: netlifyContext,
                deploymentUrl: netlifyDeploymentUrl,
                deploymentId: netlifyDeploymentId,
            },
        }); });
    };
    NetlifyConfig.prototype.injectPlatformMetadata = function (logEvent, source) {
        logEvent.netlify = {
            environment: this.environment,
            region: source === 'edge' ? process.env.DENO_REGION : process.env.AWS_REGION,
            source: source + '-log',
            siteId: netlifySiteId,
            buildId: netlifyBuildId,
            context: netlifyContext,
            deploymentUrl: netlifyDeploymentUrl,
            deploymentId: source === 'edge' ? process.env.DENO_DEPLOYMENT_ID : netlifyDeploymentId,
        };
    };
    return NetlifyConfig;
}(generic_1.default));
exports["default"] = NetlifyConfig;
//# sourceMappingURL=netlify.js.map

/***/ }),

/***/ 74243:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(34155);

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var generic_1 = __importDefault(__webpack_require__(48271));
var ingestEndpoint = process.env.NEXT_PUBLIC_AXIOM_INGEST_ENDPOINT || process.env.AXIOM_INGEST_ENDPOINT || '';
var VercelConfig = /** @class */ (function (_super) {
    __extends(VercelConfig, _super);
    function VercelConfig() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.provider = 'vercel';
        _this.shoudSendEdgeReport = true;
        _this.region = process.env.VERCEL_REGION || undefined;
        _this.environment = process.env.VERCEL_ENV || "production";
        _this.token = undefined;
        _this.axiomUrl = ingestEndpoint;
        return _this;
    }
    VercelConfig.prototype.isEnvVarsSet = function () {
        return ingestEndpoint != undefined && ingestEndpoint != '';
    };
    VercelConfig.prototype.getIngestURL = function (t) {
        var url = new URL(this.axiomUrl);
        url.searchParams.set('type', t.toString());
        return url.toString();
    };
    VercelConfig.prototype.getWebVitalsEndpoint = function () {
        return "".concat(this.proxyPath, "/web-vitals");
    };
    VercelConfig.prototype.wrapWebVitalsObject = function (metrics) {
        return {
            webVitals: metrics,
            environment: this.environment,
        };
    };
    VercelConfig.prototype.injectPlatformMetadata = function (logEvent, source) {
        logEvent.vercel = {
            environment: this.environment,
            region: this.region,
            source: source,
        };
    };
    return VercelConfig;
}(generic_1.default));
exports["default"] = VercelConfig;
//# sourceMappingURL=vercel.js.map

/***/ }),

/***/ 19690:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(34155);

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.throttle = exports.EndpointType = exports.isNoPrettyPrint = void 0;
exports.isNoPrettyPrint = process.env.AXIOM_NO_PRETTY_PRINT == 'true' ? true : false;
var EndpointType;
(function (EndpointType) {
    EndpointType["webVitals"] = "web-vitals";
    EndpointType["logs"] = "logs";
})(EndpointType = exports.EndpointType || (exports.EndpointType = {}));
var throttle = function (fn, wait) {
    var lastFn, lastTime;
    return function () {
        var context = this, args = arguments;
        // First call, set lastTime
        if (lastTime == null) {
            lastTime = Date.now();
        }
        clearTimeout(lastFn);
        lastFn = setTimeout(function () {
            if (Date.now() - lastTime >= wait) {
                fn.apply(context, args);
                lastTime = Date.now();
            }
        }, Math.max(wait - (Date.now() - lastTime), 0));
    };
};
exports.throttle = throttle;
//# sourceMappingURL=shared.js.map

/***/ }),

/***/ 20921:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.reportWebVitals = void 0;
var shared_1 = __webpack_require__(19690);
var config_1 = __importStar(__webpack_require__(82254));
var url = config_1.default.getWebVitalsEndpoint();
var throttledSendMetrics = (0, shared_1.throttle)(sendMetrics, 1000);
var collectedMetrics = [];
function reportWebVitals(metric) {
    var _a;
    collectedMetrics.push(__assign({ route: (_a = window.__NEXT_DATA__) === null || _a === void 0 ? void 0 : _a.page }, metric));
    // if Axiom env vars are not set, do nothing,
    // otherwise devs will get errors on dev environments
    if (!config_1.default.isEnvVarsSet()) {
        return;
    }
    throttledSendMetrics();
}
exports.reportWebVitals = reportWebVitals;
function sendMetrics() {
    var body = JSON.stringify(config_1.default.wrapWebVitalsObject(collectedMetrics));
    var headers = {
        'Content-Type': 'application/json',
    };
    if (config_1.default.token) {
        headers['Authorization'] = "Bearer ".concat(config_1.default.token);
    }
    var reqOptions = { body: body, method: 'POST', keepalive: true, headers: headers };
    function sendFallback() {
        // Do not leak network errors; does not affect the running app
        fetch(url, reqOptions).catch(console.error);
    }
    if (config_1.default.isBrowser && config_1.isVercel && navigator.sendBeacon) {
        try {
            // See https://github.com/vercel/next.js/pull/26601
            // Navigator has to be bound to ensure it does not error in some browsers
            // https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
            navigator.sendBeacon.bind(navigator)(url, body);
        }
        catch (err) {
            sendFallback();
        }
    }
    else {
        sendFallback();
    }
    collectedMetrics = [];
}
//# sourceMappingURL=webVitals.js.map

/***/ }),

/***/ 42726:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.withAxiom = void 0;
var logger_1 = __webpack_require__(55709);
var shared_1 = __webpack_require__(19690);
var config_1 = __importDefault(__webpack_require__(82254));
function withAxiomNextConfig(nextConfig) {
    var _this = this;
    return __assign(__assign({}, nextConfig), { rewrites: function () { return __awaiter(_this, void 0, void 0, function () {
            var rewrites, webVitalsEndpoint, logsEndpoint, log, axiomRewrites;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ((_a = nextConfig.rewrites) === null || _a === void 0 ? void 0 : _a.call(nextConfig))];
                    case 1:
                        rewrites = _b.sent();
                        webVitalsEndpoint = config_1.default.getIngestURL(shared_1.EndpointType.webVitals);
                        logsEndpoint = config_1.default.getIngestURL(shared_1.EndpointType.logs);
                        if (!webVitalsEndpoint && !logsEndpoint) {
                            log = new logger_1.Logger();
                            log.warn('axiom: Envvars not detected. If this is production please see https://github.com/axiomhq/next-axiom for help');
                            log.warn('axiom: Sending Web Vitals to /dev/null');
                            log.warn('axiom: Sending logs to console');
                            return [2 /*return*/, rewrites || []]; // nothing to do
                        }
                        axiomRewrites = [
                            {
                                source: "".concat(config_1.default.proxyPath, "/web-vitals"),
                                destination: webVitalsEndpoint,
                                basePath: false,
                            },
                            {
                                source: "".concat(config_1.default.proxyPath, "/logs"),
                                destination: logsEndpoint,
                                basePath: false,
                            },
                        ];
                        if (!rewrites) {
                            return [2 /*return*/, axiomRewrites];
                        }
                        else if (Array.isArray(rewrites)) {
                            return [2 /*return*/, rewrites.concat(axiomRewrites)];
                        }
                        else {
                            rewrites.afterFiles = (rewrites.afterFiles || []).concat(axiomRewrites);
                            return [2 /*return*/, rewrites];
                        }
                        return [2 /*return*/];
                }
            });
        }); } });
}
// Sending logs after res.{json,send,end} is very unreliable.
// This function overwrites these functions and makes sure logs are sent out
// before the response is sent.
function interceptNextApiResponse(req, res) {
    var _this = this;
    var allPromises = [];
    var resSend = res.send;
    res.send = function (body) {
        allPromises.push((function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        req.log.attachResponseStatus(res.statusCode);
                        return [4 /*yield*/, req.log.flush()];
                    case 1:
                        _a.sent();
                        resSend(body);
                        return [2 /*return*/];
                }
            });
        }); })());
    };
    var resJson = res.json;
    res.json = function (json) {
        allPromises.push((function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        req.log.attachResponseStatus(res.statusCode);
                        return [4 /*yield*/, req.log.flush()];
                    case 1:
                        _a.sent();
                        resJson(json);
                        return [2 /*return*/];
                }
            });
        }); })());
    };
    var resEnd = res.end;
    res.end = function (cb) {
        allPromises.push((function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        req.log.attachResponseStatus(res.statusCode);
                        return [4 /*yield*/, req.log.flush()];
                    case 1:
                        _a.sent();
                        resEnd(cb);
                        return [2 /*return*/];
                }
            });
        }); })());
        return res;
    };
    return [res, allPromises];
}
function withAxiomNextApiHandler(handler) {
    var _this = this;
    return function (req, res) { return __awaiter(_this, void 0, void 0, function () {
        var report, logger, axiomRequest, _a, wrappedRes, allPromises, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    report = config_1.default.generateRequestMeta(req);
                    logger = new logger_1.Logger({}, report, false, 'lambda');
                    axiomRequest = req;
                    axiomRequest.log = logger;
                    _a = interceptNextApiResponse(axiomRequest, res), wrappedRes = _a[0], allPromises = _a[1];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 5, , 8]);
                    return [4 /*yield*/, handler(axiomRequest, wrappedRes)];
                case 2:
                    _b.sent();
                    return [4 /*yield*/, logger.flush()];
                case 3:
                    _b.sent();
                    return [4 /*yield*/, Promise.all(allPromises)];
                case 4:
                    _b.sent();
                    return [3 /*break*/, 8];
                case 5:
                    error_1 = _b.sent();
                    logger.error('Error in API handler', { error: error_1 });
                    logger.attachResponseStatus(500);
                    return [4 /*yield*/, logger.flush()];
                case 6:
                    _b.sent();
                    return [4 /*yield*/, Promise.all(allPromises)];
                case 7:
                    _b.sent();
                    throw error_1;
                case 8: return [2 /*return*/];
            }
        });
    }); };
}
function withAxiomNextEdgeFunction(handler) {
    var _this = this;
    return function (req, ev) { return __awaiter(_this, void 0, void 0, function () {
        var report, logger, axiomRequest, res, error_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    report = {
                        startTime: new Date().getTime(),
                        ip: req.ip,
                        region: (_a = req.geo) === null || _a === void 0 ? void 0 : _a.region,
                        host: req.nextUrl.host,
                        method: req.method,
                        path: req.nextUrl.pathname,
                        scheme: req.nextUrl.protocol.replace(':', ''),
                        userAgent: req.headers.get('user-agent'),
                    };
                    logger = new logger_1.Logger({}, report, false, 'edge');
                    axiomRequest = req;
                    axiomRequest.log = logger;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, handler(axiomRequest, ev)];
                case 2:
                    res = _b.sent();
                    if (res) {
                        logger.attachResponseStatus(res.status);
                    }
                    ev.waitUntil(logger.flush());
                    logEdgeReport(report);
                    return [2 /*return*/, res];
                case 3:
                    error_2 = _b.sent();
                    logger.error('Error in edge function', { error: error_2 });
                    logger.attachResponseStatus(500);
                    ev.waitUntil(logger.flush());
                    logEdgeReport(report);
                    throw error_2;
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
function logEdgeReport(report) {
    if (config_1.default.shoudSendEdgeReport) {
        console.log("AXIOM_EDGE_REPORT::".concat(JSON.stringify(report)));
    }
}
function isNextConfig(param) {
    return typeof param == 'object';
}
function isApiHandler(param) {
    var isFunction = typeof param == 'function';
    // Vercel defines EdgeRuntime for edge functions, but Netlify defines NEXT_RUNTIME = 'edge'
    return isFunction && typeof globalThis.EdgeRuntime === 'undefined' && undefined != 'edge';
}
// withAxiom can be called either with NextConfig, which will add proxy rewrites
// to improve deliverability of Web-Vitals and logs, or with NextApiRequest or
// NextMiddleware which will automatically log exceptions and flush logs.
function withAxiom(param) {
    if (isNextConfig(param)) {
        return withAxiomNextConfig(param);
    }
    else if (isApiHandler(param)) {
        return withAxiomNextApiHandler(param);
    }
    else {
        return withAxiomNextEdgeFunction(param);
    }
}
exports.withAxiom = withAxiom;
//# sourceMappingURL=withAxiom.js.map

/***/ }),

/***/ 66477:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

/* globals self */ exports.Headers = self.Headers;
exports.Request = self.Request;
exports.Response = self.Response;
exports.fetch = self.fetch;

//# sourceMappingURL=whatwg-fetch.js.map

/***/ }),

/***/ 6840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(36331);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 97690:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/meta-image.f5d10b7f.jpg","height":2508,"width":4800,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAeEAABBAEFAAAAAAAAAAAAAAABAAIEESEDBRMxYf/EABUBAQEAAAAAAAAAAAAAAAAAAAMG/8QAGxEAAgEFAAAAAAAAAAAAAAAAAAFBAgMREsH/2gAMAwEAAhEDEQA/AIPcZfFOiFsfQJOLcy6z2PURFWbNXK8OeIaWf//Z","blurWidth":8,"blurHeight":4});

/***/ }),

/***/ 50745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Meta; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _public_images_meta_image_jpg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97690);



const Meta = (param)=>{
    let { title , description , absoluteImageUrl , canonical  } = param;
    const img = absoluteImageUrl || "https://".concat("highlight-landing-k3brijlsv-highlight-run.vercel.app").concat(_public_images_meta_image_jpg__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }, "description"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }, "twcard"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: "@highlightrun"
            }, "twsite"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:creator",
                content: "@highlightrun"
            }, "twcreator"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: img
            }, "twimage"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }, "twtitle"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: "highlight.io"
            }, "ogurl"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }, "ogtype"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: img
            }, "ogimage"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: "Highlight"
            }, "ogsitename"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }, "ogtitle"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }, "ogdesc"),
            canonical && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: "https://www.highlight.io".concat(canonical)
            })
        ]
    });
};


/***/ }),

/***/ 36331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; },
  "reportWebVitals": function() { return /* reexport */ dist/* reportWebVitals */.U9; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/nprogress/nprogress.js
var nprogress = __webpack_require__(74865);
var nprogress_default = /*#__PURE__*/__webpack_require__.n(nprogress);
// EXTERNAL MODULE: ./styles/globals.scss
var globals = __webpack_require__(48339);
// EXTERNAL MODULE: ./styles/nprogress.css
var styles_nprogress = __webpack_require__(61348);
// EXTERNAL MODULE: ./styles/public.css
var styles_public = __webpack_require__(62834);
// EXTERNAL MODULE: ./public/images/meta-image.jpg
var meta_image = __webpack_require__(97690);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/common/Head/Meta.tsx
var Meta = __webpack_require__(50745);
// EXTERNAL MODULE: ./node_modules/next-axiom/dist/index.js
var dist = __webpack_require__(42029);
;// CONCATENATED MODULE: ./node_modules/highlight.run/dist/indexESM.js
var ke="highlight.run",Se="5.3.1",Ee={build:"yarn typegen && rollup -c",dev:"rollup -c -w","enforce-size":"size-limit",test:"vitest --run",typegen:"tsc"},Ne="dist/index.js",_e="dist/indexESM.js",Te="dist/firstload/src/index.d.ts",xe="MIT",Le={"@rollup/plugin-commonjs":"^22.0.1","@rollup/plugin-json":"^4.1.0","@rollup/plugin-node-resolve":"^15.0.1","@rollup/plugin-replace":"^4.0.0","@size-limit/file":"^8.1.0","@types/chrome":"^0.0.144",esbuild:"^0.14.47",rollup:"^2.79.1","rollup-plugin-consts":"^1.1.0","rollup-plugin-esbuild":"^4.9.1","rollup-plugin-filesize":"^9.1.2","rollup-plugin-web-worker-loader":"^1.6.1","size-limit":"^8.1.0",tslib:"^2.4.0",typescript:"^4.0.3",vitest:"^0.23.4"},q={name:ke,version:Se,scripts:Ee,main:Ne,module:_e,types:Te,license:xe,devDependencies:Le,"size-limit":[{path:"dist/**.js",limit:"26 kB",brotli:!0}]};const Ie=()=>{var t,e;typeof chrome!="undefined"&&((t=chrome==null?void 0:chrome.runtime)==null?void 0:t.onMessage)&&((e=chrome==null?void 0:chrome.runtime)==null||e.onMessage.addListener((r,o,l)=>{const u=r.action;switch(console.log(`[highlight] received '${u}' event from extension.`),u){case"init":{const s="http://localhost:8080/dist/index.js";console.log("url",s),w.init(1,{debug:!0,scriptUrl:s}),w.getSessionURL().then(i=>{l({url:i})});break}case"stop":{w.stop(),l({success:!0});break}}return!0}))},Ce=({apiKey:t})=>{(function(e,r){var o=e.amplitude||{_q:[],_iq:{}},l=r.createElement("script");l.type="text/javascript",l.integrity="sha384-+EO59vL/X7v6VE2s6/F4HxfHlK0nDUVWKVg8K9oUlvffAeeaShVBmbORTC2D3UF+",l.crossOrigin="anonymous",l.async=!0,l.src="https://cdn.amplitude.com/libs/amplitude-8.17.0-min.gz.js",l.onload=function(){e.amplitude.runQueuedFunctions||console.log("[Amplitude] Error: could not load SDK"),amplitude.getInstance().init(t)};var u=r.getElementsByTagName("script")[0];u.parentNode.insertBefore(l,u);function s(f,m){f.prototype[m]=function(){return this._q.push([m].concat(Array.prototype.slice.call(arguments,0))),this}}for(var i=function(){return this._q=[],this},n=["add","append","clearAll","prepend","set","setOnce","unset","preInsert","postInsert","remove"],c=0;c<n.length;c++)s(i,n[c]);o.Identify=i;for(var a=function(){return this._q=[],this},d=["setProductId","setQuantity","setPrice","setRevenueType","setEventProperties"],p=0;p<d.length;p++)s(a,d[p]);o.Revenue=a;var h=["init","logEvent","logRevenue","setUserId","setUserProperties","setOptOut","setVersionName","setDomain","setDeviceId","enableTracking","setGlobalUserProperties","identify","clearUserProperties","setGroup","logRevenueV2","regenerateDeviceId","groupIdentify","onInit","logEventWithTimestamp","logEventWithGroups","setSessionId","resetSessionId"];function g(f){function m(b){f[b]=function(){f._q.push([b].concat(Array.prototype.slice.call(arguments,0)))}}for(var y=0;y<h.length;y++)m(h[y])}g(o),o.getInstance=function(f){return f=(!f||f.length===0?"$default_instance":f).toLowerCase(),Object.prototype.hasOwnProperty.call(o._iq,f)||(o._iq[f]={_q:[]},g(o._iq[f])),o._iq[f]},e.amplitude=o})(window,document)},He=({projectToken:t})=>{if(window.mixpanel)return;(function(r,o){if(!o.__SV){var l,u;window.mixpanel=o,o._i=[],o.init=function(s,i,n){function c(p,h){var g=h.split(".");g.length==2&&(p=p[g[0]],h=g[1]),p[h]=function(){p.push([h].concat(Array.prototype.slice.call(arguments,0)))}}var a=o;for(typeof n!="undefined"?a=o[n]=[]:n="mixpanel",a.people=a.people||[],a.toString=function(p){var h="mixpanel";return n!=="mixpanel"&&(h+="."+n),p||(h+=" (stub)"),h},a.people.toString=function(){return a.toString(1)+".people (stub)"},l="disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking start_batch_senders people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove".split(" "),u=0;u<l.length;u++)c(a,l[u]);var d="set set_once union unset remove delete".split(" ");a.get_group=function(){function p(m){h[m]=function(){call2_args=arguments,call2=[m].concat(Array.prototype.slice.call(call2_args,0)),a.push([g,call2])}}for(var h={},g=["get_group"].concat(Array.prototype.slice.call(arguments,0)),f=0;f<d.length;f++)p(d[f]);return h},o._i.push([s,i,n])},o.__SV=1.2}})(document,window.mixpanel||[]);const e=document.createElement("script");e.src=Pe,document.head.appendChild(e),e.addEventListener("load",()=>{var r;(r=window.mixpanel)==null||r.init(t)})},Pe="https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js",$e=()=>{typeof window=="undefined"||typeof document=="undefined"||(window._originalFetch=window.fetch,window._fetchProxy=(t,e)=>window._originalFetch(t,e),window._highlightFetchPatch=(t,e)=>window._fetchProxy.call(window||__webpack_require__.g,t,e),window.fetch=window._highlightFetchPatch)};var B=(t=>(t.RECORDING_START_TIME="highlightRecordingStartTime",t.SEGMENT_LAST_SENT_HASH_KEY="HIGHLIGHT_SEGMENT_LAST_SENT_HASH_KEY",t.SESSION_DATA="sessionData",t.SESSION_SECURE_ID="sessionSecureID",t.USER_IDENTIFIER="highlightIdentifier",t.USER_OBJECT="highlightUserObject",t.PAYLOAD_ID="payloadId",t))(B||{});const je=1e3*55,Ae=()=>{let t=JSON.parse(window.sessionStorage.getItem(B.SESSION_DATA)||"{}");if(t&&t.lastPushTime&&Date.now()-t.lastPushTime<je)return t};function De(t,e,r){try{if(!(e in t))return()=>{};const o=t[e],l=r(o);return typeof l=="function"&&(l.prototype=l.prototype||{},Object.defineProperties(l,{__rrweb_original__:{enumerable:!1,value:o}})),t[e]=l,()=>{t[e]=o}}catch(o){return()=>{}}}function qe(t){if(!t||!t.outerHTML)return"";let e="";for(;t.parentElement;){let r=t.localName;if(!r)break;r=r.toLowerCase();let o=t.parentElement,l=[];if(o.children&&o.children.length>0)for(let u=0;u<o.children.length;u++){let s=o.children[u];s.localName&&s.localName.toLowerCase&&s.localName.toLowerCase()===r&&l.push(s)}l.length>1&&(r+=":eq("+l.indexOf(t)+")"),e=r+(e?">"+e:""),t=o}return e}function L(t){return Object.prototype.toString.call(t)==="[object Object]"}function U(t,e){if(e===0)return!0;const r=Object.keys(t);for(const o of r)if(L(t[o])&&U(t[o],e-1))return!0;return!1}function M(t,e){const r={numOfKeysLimit:50,depthOfLimit:4};Object.assign(r,e);const o=[],l=[];return JSON.stringify(t,function(i,n){if(o.length>0){const c=o.indexOf(this);~c?o.splice(c+1):o.push(this),~c?l.splice(c,1/0,i):l.push(i),~o.indexOf(n)&&(o[0]===n?n="[Circular ~]":n="[Circular ~."+l.slice(0,o.indexOf(n)).join(".")+"]")}else o.push(n);if(n==null)return n;if(u(n))return s(n);if(n instanceof Event){const c={};for(const a in n){const d=n[a];Array.isArray(d)?c[a]=qe(d.length?d[0]:null):c[a]=d}return c}else{if(n instanceof Node)return n instanceof HTMLElement?n?n.outerHTML:"":n.nodeName;if(n instanceof Error)return n.name+": "+n.message}return n});function u(i){return L(i)&&Object.keys(i).length>r.numOfKeysLimit||typeof i=="function"?!0:i instanceof Event&&i.isTrusted===!1?Object.keys(i).length===1:!!(L(i)&&U(i,r.depthOfLimit))}function s(i){let n=i.toString();return r.stringLengthLimit&&n.length>r.stringLengthLimit&&(n=`${n.slice(0,r.stringLengthLimit)}...`),n}}var F=typeof globalThis!="undefined"?globalThis:typeof window!="undefined"?window:typeof __webpack_require__.g!="undefined"?__webpack_require__.g:typeof self!="undefined"?self:{},K={exports:{}},I={exports:{}},z;function Be(){return z||(z=1,function(t,e){(function(r,o){t.exports=o()})(F,function(){function r(f){return!isNaN(parseFloat(f))&&isFinite(f)}function o(f){return f.charAt(0).toUpperCase()+f.substring(1)}function l(f){return function(){return this[f]}}var u=["isConstructor","isEval","isNative","isToplevel"],s=["columnNumber","lineNumber"],i=["fileName","functionName","source"],n=["args"],c=["evalOrigin"],a=u.concat(s,i,n,c);function d(f){if(!!f)for(var m=0;m<a.length;m++)f[a[m]]!==void 0&&this["set"+o(a[m])](f[a[m]])}d.prototype={getArgs:function(){return this.args},setArgs:function(f){if(Object.prototype.toString.call(f)!=="[object Array]")throw new TypeError("Args must be an Array");this.args=f},getEvalOrigin:function(){return this.evalOrigin},setEvalOrigin:function(f){if(f instanceof d)this.evalOrigin=f;else if(f instanceof Object)this.evalOrigin=new d(f);else throw new TypeError("Eval Origin must be an Object or StackFrame")},toString:function(){var f=this.getFileName()||"",m=this.getLineNumber()||"",y=this.getColumnNumber()||"",b=this.getFunctionName()||"";return this.getIsEval()?f?"[eval] ("+f+":"+m+":"+y+")":"[eval]:"+m+":"+y:b?b+" ("+f+":"+m+":"+y+")":f+":"+m+":"+y}},d.fromString=function(m){var y=m.indexOf("("),b=m.lastIndexOf(")"),T=m.substring(0,y),ye=m.substring(y+1,b).split(","),D=m.substring(b+1);if(D.indexOf("@")===0)var x=/@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(D,""),be=x[1],Re=x[2],Oe=x[3];return new d({functionName:T,args:ye||void 0,fileName:be,lineNumber:Re||void 0,columnNumber:Oe||void 0})};for(var p=0;p<u.length;p++)d.prototype["get"+o(u[p])]=l(u[p]),d.prototype["set"+o(u[p])]=function(f){return function(m){this[f]=Boolean(m)}}(u[p]);for(var h=0;h<s.length;h++)d.prototype["get"+o(s[h])]=l(s[h]),d.prototype["set"+o(s[h])]=function(f){return function(m){if(!r(m))throw new TypeError(f+" must be a Number");this[f]=Number(m)}}(s[h]);for(var g=0;g<i.length;g++)d.prototype["get"+o(i[g])]=l(i[g]),d.prototype["set"+o(i[g])]=function(f){return function(m){this[f]=String(m)}}(i[g]);return d})}(I)),I.exports}(function(t,e){(function(r,o){t.exports=o(Be())})(F,function(o){var l=/(^|@)\S+:\d+/,u=/^\s*at .*(\S+:\d+|\(native\))/m,s=/^(eval@)?(\[native code])?$/;return{parse:function(n){if(typeof n.stacktrace!="undefined"||typeof n["opera#sourceloc"]!="undefined")return this.parseOpera(n);if(n.stack&&n.stack.match(u))return this.parseV8OrIE(n);if(n.stack)return this.parseFFOrSafari(n);throw new Error("Cannot parse given Error object")},extractLocation:function(n){if(n.indexOf(":")===-1)return[n];var c=/(.+?)(?::(\d+))?(?::(\d+))?$/,a=c.exec(n.replace(/[()]/g,""));return[a[1],a[2]||void 0,a[3]||void 0]},parseV8OrIE:function(n){var c=n.stack.split(`
`).filter(function(a){return!!a.match(u)},this);return c.map(function(a){a.indexOf("(eval ")>-1&&(a=a.replace(/eval code/g,"eval").replace(/(\(eval at [^()]*)|(\),.*$)/g,""));var d=a.replace(/^\s+/,"").replace(/\(eval code/g,"("),p=d.match(/ (\((.+):(\d+):(\d+)\)$)/);d=p?d.replace(p[0],""):d;var h=d.split(/\s+/).slice(1),g=this.extractLocation(p?p[1]:h.pop()),f=h.join(" ")||void 0,m=["eval","<anonymous>"].indexOf(g[0])>-1?void 0:g[0];return new o({functionName:f,fileName:m,lineNumber:g[1],columnNumber:g[2],source:a})},this)},parseFFOrSafari:function(n){var c=n.stack.split(`
`).filter(function(a){return!a.match(s)},this);return c.map(function(a){if(a.indexOf(" > eval")>-1&&(a=a.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g,":$1")),a.indexOf("@")===-1&&a.indexOf(":")===-1)return new o({functionName:a});var d=/((.*".+"[^@]*)?[^@]*)(?:@)/,p=a.match(d),h=p&&p[1]?p[1]:void 0,g=this.extractLocation(a.replace(d,""));return new o({functionName:h,fileName:g[0],lineNumber:g[1],columnNumber:g[2],source:a})},this)},parseOpera:function(n){return!n.stacktrace||n.message.indexOf(`
`)>-1&&n.message.split(`
`).length>n.stacktrace.split(`
`).length?this.parseOpera9(n):n.stack?this.parseOpera11(n):this.parseOpera10(n)},parseOpera9:function(n){for(var c=/Line (\d+).*script (?:in )?(\S+)/i,a=n.message.split(`
`),d=[],p=2,h=a.length;p<h;p+=2){var g=c.exec(a[p]);g&&d.push(new o({fileName:g[2],lineNumber:g[1],source:a[p]}))}return d},parseOpera10:function(n){for(var c=/Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i,a=n.stacktrace.split(`
`),d=[],p=0,h=a.length;p<h;p+=2){var g=c.exec(a[p]);g&&d.push(new o({functionName:g[3]||void 0,fileName:g[2],lineNumber:g[1],source:a[p]}))}return d},parseOpera11:function(n){var c=n.stack.split(`
`).filter(function(a){return!!a.match(l)&&!a.match(/^Error created at/)},this);return c.map(function(a){var d=a.split("@"),p=this.extractLocation(d.pop()),h=d.shift()||"",g=h.replace(/<anonymous function(: (\w+))?>/,"$2").replace(/\([^)]*\)/g,"")||void 0,f;h.match(/\(([^)]*)\)/)&&(f=h.replace(/^[^(]+\(([^)]*)\)$/,"$1"));var m=f===void 0||f==="[arguments not available]"?void 0:f.split(",");return new o({functionName:g,args:m,fileName:p[0],lineNumber:p[1],columnNumber:p[2],source:a})},this)}}})})(K);var C=K.exports;function Ue(t,e){const r=e.logger;if(!r)return()=>{};let o;typeof r=="string"?o=window[r]:o=r;const l=[];if(e.level.includes("error")&&window){const s=i=>{const{message:n,error:c}=i;let a=[];c&&(a=C.parse(c));const d=[M(n,e.stringifyOptions)];t({type:"Error",trace:a.slice(1),time:Date.now(),value:d})};window.addEventListener("error",s),l.push(()=>{window&&window.removeEventListener("error",s)})}for(const s of e.level)l.push(u(o,s));return()=>{l.forEach(s=>s())};function u(s,i){return s[i]?De(s,i,n=>(...c)=>{n.apply(this,c);try{const a=C.parse(new Error),d=c.map(p=>M(p,e.stringifyOptions));t({type:i,trace:a.slice(1),value:d,time:Date.now()})}catch(a){n("highlight logger error:",a,...c)}}):()=>{}}}var H={exports:{}};(function(t,e){e=t.exports=r,e.getSerialize=o;function r(l,u,s,i){return JSON.stringify(l,o(u,i),s)}function o(l,u){var s=[],i=[];return u==null&&(u=function(n,c){return s[0]===c?"[Circular ~]":"[Circular ~."+i.slice(0,s.indexOf(c)).join(".")+"]"}),function(n,c){if(s.length>0){var a=s.indexOf(this);~a?s.splice(a+1):s.push(this),~a?i.splice(a,1/0,n):i.push(n),~s.indexOf(c)&&(c=u.call(this,n,c))}else s.push(c);return l==null?c:l.call(this,n,c)}}})(H,H.exports);var V=H.exports;const Me=t=>{const e=window.onerror;return window.onerror=(r,o,l,u,s)=>{var i,n,c,a;if(s){let d=[];try{d=C.parse(s)}catch(h){}const p=Fe(d);t({event:V(r),type:"window.onerror",url:window.location.href,source:o||"",lineNumber:(i=p[0])!=null&&i.lineNumber?(n=p[0])==null?void 0:n.lineNumber:0,columnNumber:(c=p[0])!=null&&c.columnNumber?(a=p[0])==null?void 0:a.columnNumber:0,stackTrace:p,timestamp:new Date().toISOString()})}},()=>{window.onerror=e}},Fe=t=>{var e;if(t.length===0)return t;const r=t[0];return r.functionName==="console.error"&&((e=r.fileName)==null?void 0:e.includes("highlight.run"))?t.slice(1):t},Ke=["assert","count","countReset","debug","dir","dirxml","error","group","groupCollapsed","groupEnd","info","log","table","time","timeEnd","timeLog","trace","warn"];var ze=(t=>(t.DeviceMemory="DeviceMemory",t.ViewportHeight="ViewportHeight",t.ViewportWidth="ViewportWidth",t.ViewportArea="ViewportArea",t))(ze||{}),Ve=(t=>(t.Device="Device",t.WebVital="WebVital",t.Frontend="Frontend",t.Backend="Backend",t))(Ve||{});const Ge=['["\\"Script error.\\""]','[{"isTrusted":true}]','["{}"]','[""]','["\\"\\""]'],We=["websocket error",'\\"ResizeObserver loop'];var Je=Object.defineProperty,Xe=Object.defineProperties,Ye=Object.getOwnPropertyDescriptors,G=Object.getOwnPropertySymbols,Qe=Object.prototype.hasOwnProperty,Ze=Object.prototype.propertyIsEnumerable,W=(t,e,r)=>e in t?Je(t,e,{enumerable:!0,configurable:!0,writable:!0,value:r}):t[e]=r,P=(t,e)=>{for(var r in e||(e={}))Qe.call(e,r)&&W(t,r,e[r]);if(G)for(var r of G(e))Ze.call(e,r)&&W(t,r,e[r]);return t},J=(t,e)=>Xe(t,Ye(e));const et=(t,e,r)=>{const o=X(e,t.headers,r);return J(P({},t),{headers:o})},tt=(t,e,r)=>{const o=X(e,t.headers,r);return J(P({},t),{headers:o})},X=(t,e,r)=>{var o,l;const u=P({},e);return r?((o=Object.keys(u))==null||o.forEach(s=>{[...r].includes(s==null?void 0:s.toLowerCase())||(u[s]="[REDACTED]")}),u):((l=Object.keys(u))==null||l.forEach(s=>{[...rt,...t].includes(s==null?void 0:s.toLowerCase())&&(u[s]="[REDACTED]")}),u)},rt=["authorization","cookie","proxy-authorization","token"],nt=["https://www.googleapis.com/identitytoolkit","https://securetoken.googleapis.com"];var Y=void 0;const Q="X-Highlight-Request",Z=t=>{let e=t;return!t.startsWith("https://")&&!t.startsWith("http://")&&(e=`${window.location.origin}${e}`),e.replace(/\/+$/,"")},ee=(t,e,r)=>{t.sort((i,n)=>i.responseEnd-n.responseEnd);const o={xmlhttprequest:{},others:{},fetch:{}},l=t.reduce((i,n)=>{const c=Z(n.name);return n.initiatorType===r?i[r][c]=[...i[r][c]||[],n]:i.others[c]=[...i.others[c]||[],n],i},o);let u={};u=e.reduce((i,n)=>{const c=Z(n.request.url);return i[c]=[...i[c]||[],n],i},u);for(let i in l[r]){const n=l[r][i],c=u[i];if(!c)continue;const a=Math.max(n.length-c.length,0);for(let d=a;d<n.length;d++)n[d]&&(n[d].requestResponsePair=c[d-a])}let s=[];for(let i in l)for(let n in l[i])s=s.concat(l[i][n]);return s.sort((i,n)=>i.fetchStart-n.fetchStart).map(i=>(i.toJSON=function(){return{initiatorType:this.initiatorType,startTime:this.startTime,responseEnd:this.responseEnd,name:this.name,transferSize:this.transferSize,encodedBodySize:this.encodedBodySize,requestResponsePairs:this.requestResponsePair}},i))},ot=(t,e)=>{var r;return t.toLocaleLowerCase().includes((r=Y)!=null?r:"highlight.run")||t.toLocaleLowerCase().includes("highlight.run")||t.toLocaleLowerCase().includes(e)},$=(t,e,r)=>!ot(t,e)||j(t,r),j=(t,e)=>{var r;let o=[];e===!0?(o=["localhost",/^\//],(r=window==null?void 0:window.location)!=null&&r.host&&o.push(window.location.host)):e instanceof Array&&(o=e);let l=!1;return o.forEach(u=>{t.match(u)&&(l=!0)}),l};function it(t){for(var e="",r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",o=r.length,l=0;l<t;l++)e+=r.charAt(Math.floor(Math.random()*o));return e}const te=()=>it(10),re=(t,e)=>t+"/"+e;var ne=(t,e,r)=>new Promise((o,l)=>{var u=n=>{try{i(r.next(n))}catch(c){l(c)}},s=n=>{try{i(r.throw(n))}catch(c){l(c)}},i=n=>n.done?o(n.value):Promise.resolve(n.value).then(u,s);i((r=r.apply(t,e)).next())});const st=(t,e,r,o,l,u)=>{const s=XMLHttpRequest.prototype,i=s.open,n=s.send,c=s.setRequestHeader;return s.open=function(a,d){return this._method=a,this._url=d,this._requestHeaders={},this._shouldRecordHeaderAndBody=!o.some(p=>d.toLowerCase().includes(p)),i.apply(this,arguments)},s.setRequestHeader=function(a,d){return this._requestHeaders[a]=d,c.apply(this,arguments)},s.send=function(a){if(!$(this._url,e,r))return n.apply(this,arguments);const d=te();j(this._url,r)&&this.setRequestHeader(Q,re(l,d));const p=this._shouldRecordHeaderAndBody,h={id:d,url:this._url,verb:this._method,headers:p?this._requestHeaders:{},body:void 0};if(p&&a){const g=oe(a,h.url);g&&(h.body=O(g,u))}return this.addEventListener("load",function(){return ne(this,null,function*(){const g={status:this.status,headers:{},body:void 0};if(p){if(a){const y=oe(a,h.url);y&&(h.body=O(y,u))}const f=this.getAllResponseHeaders().trim().split(/[\r\n]+/),m={};if(f.forEach(function(y){const b=y.split(": "),T=b.shift();m[T]=b.join(": ")}),g.headers=m,this.responseType===""||this.responseType==="text")g.body=O(this.responseText,u),g.size=this.responseText.length*8;else if(this.responseType==="blob"){const y=this.response,b=yield y.text();g.body=O(b,u),g.size=y.size}else try{g.body=O(this.response,u)}catch(y){}}t({request:h,response:g,urlBlocked:!p})})}),this.addEventListener("error",function(){return ne(this,null,function*(){const g={status:this.status,headers:void 0,body:void 0};t({request:h,response:g,urlBlocked:!1})})}),n.apply(this,arguments)},()=>{s.open=i,s.send=n,s.setRequestHeader=c}},oe=(t,e)=>{if(typeof t=="string"){if(!(((e==null?void 0:e.includes("localhost"))||(e==null?void 0:e.includes("highlight.run")))&&t.includes("pushPayload")))return t}else if(typeof t=="object"||typeof t=="number"||typeof t=="boolean")return t.toString();return null},O=(t,e)=>{if(!e||!t)return t;try{const r=JSON.parse(t);return Object.keys(r).forEach(o=>{e.includes(o.toLocaleLowerCase())||(r[o]="[REDACTED]")}),JSON.stringify(r)}catch(r){}return t};var at=Object.defineProperty,lt=Object.defineProperties,ct=Object.getOwnPropertyDescriptors,ie=Object.getOwnPropertySymbols,ut=Object.prototype.hasOwnProperty,dt=Object.prototype.propertyIsEnumerable,se=(t,e,r)=>e in t?at(t,e,{enumerable:!0,configurable:!0,writable:!0,value:r}):t[e]=r,ae=(t,e)=>{for(var r in e||(e={}))ut.call(e,r)&&se(t,r,e[r]);if(ie)for(var r of ie(e))dt.call(e,r)&&se(t,r,e[r]);return t},le=(t,e)=>lt(t,ct(e)),pt=(t,e,r)=>new Promise((o,l)=>{var u=n=>{try{i(r.next(n))}catch(c){l(c)}},s=n=>{try{i(r.throw(n))}catch(c){l(c)}},i=n=>n.done?o(n.value):Promise.resolve(n.value).then(u,s);i((r=r.apply(t,e)).next())});const ft=(t,e,r,o,l,u)=>{const s=window._fetchProxy;return window._fetchProxy=function(i,n){const{method:c,url:a}=gt(i,n);if(!$(a,e,r))return s.call(this,i,n);const d=te();if(j(a,r)){n=n||{};let f=new Headers(n.headers);f.set(Q,re(l,d)),n.headers=Object.fromEntries(f.entries())}const p={id:d,headers:{},body:void 0,url:a,verb:c},h=!o.some(f=>a.toLowerCase().includes(f));h&&(p.headers=Object.fromEntries(new Headers(n==null?void 0:n.headers).entries()),p.body=O(n==null?void 0:n.body,u));let g=s.call(this,i,n);return ht(g,p,t,h,u),g},()=>{window._fetchProxy=s}},gt=(t,e)=>{const r=e&&e.method||typeof t=="object"&&"method"in t&&t.method||"GET";let o;return typeof t=="object"?"url"in t&&t.url?o=t.url:o=t.toString():o=t,{method:r,url:o}},ht=(t,e,r,o,l)=>{const u=s=>pt(void 0,null,function*(){let i={body:void 0,headers:void 0,status:0,size:0},n=!1;if("stack"in s||s instanceof Error)i=le(ae({},i),{body:s.message,status:0,size:void 0}),n=!0;else if("status"in s){if(i=le(ae({},i),{status:s.status}),o){let c;try{const a=s.clone().body;if(a){let d=a.getReader(),p=new TextDecoder,h,g="";for(;!(h=yield d.read()).done;){let f=h.value;g+=p.decode(f)}c=g,c=O(c,l)}else c=""}catch(a){c=`Unable to clone response: ${a}`}i.body=c,i.headers=Object.fromEntries(s.headers.entries()),i.size=c.length*8}n=!0}n&&r({request:e,response:i,urlBlocked:!o})});t.then(u).catch(()=>{})};var mt=Object.defineProperty,S=Object.getOwnPropertySymbols,ce=Object.prototype.hasOwnProperty,ue=Object.prototype.propertyIsEnumerable,de=(t,e,r)=>e in t?mt(t,e,{enumerable:!0,configurable:!0,writable:!0,value:r}):t[e]=r,vt=(t,e)=>{for(var r in e||(e={}))ce.call(e,r)&&de(t,r,e[r]);if(S)for(var r of S(e))ue.call(e,r)&&de(t,r,e[r]);return t},wt=(t,e)=>{var r={};for(var o in t)ce.call(t,o)&&e.indexOf(o)<0&&(r[o]=t[o]);if(t!=null&&S)for(var o of S(t))e.indexOf(o)<0&&ue.call(t,o)&&(r[o]=t[o]);return r};const yt=({xhrCallback:t,fetchCallback:e,headersToRedact:r,backendUrl:o,tracingOrigins:l,urlBlocklist:u,sessionSecureID:s,bodyKeysToRecord:i,headerKeysToRecord:n})=>{const c=st(d=>{t(pe(d,r,n))},o,l,u,s,i),a=ft(d=>{e(pe(d,r,n))},o,l,u,s,i);return()=>{c(),a()}},pe=(t,e,r)=>{var o=t,{request:l,response:u}=o,s=wt(o,["request","response"]);return vt({request:et(l,e,r),response:tt(u,e,r)},s)};var bt=Object.defineProperty,Rt=Object.defineProperties,Ot=Object.getOwnPropertyDescriptors,fe=Object.getOwnPropertySymbols,kt=Object.prototype.hasOwnProperty,St=Object.prototype.propertyIsEnumerable,ge=(t,e,r)=>e in t?bt(t,e,{enumerable:!0,configurable:!0,writable:!0,value:r}):t[e]=r,Et=(t,e)=>{for(var r in e||(e={}))kt.call(e,r)&&ge(t,r,e[r]);if(fe)for(var r of fe(e))St.call(e,r)&&ge(t,r,e[r]);return t},Nt=(t,e)=>Rt(t,Ot(e));class A{constructor(e){this.hasNetworkRecording=!0,this.options=e,this.disableConsoleRecording=window.location.hostname==="localhost"||!!e.disableConsoleRecording,this.consoleMethodsToRecord=e.consoleMethodsToRecord||[...Ke],this.listeners=[],this.errors=[],this.messages=[]}isListening(){return this.listeners.length>0}startListening(){if(this.isListening())return;const e=this;this.disableConsoleRecording||this.listeners.push(Ue(r=>{var o,l,u;if((r.type==="Error"||r.type==="error")&&r.value&&r.trace){const s=V(r.value);if(Ge.includes(s)||We.some(i=>s.includes(i)))return;e.errors.push({event:s,type:"console.error",url:window.location.href,source:(o=r.trace[0])!=null&&o.fileName?r.trace[0].fileName:"",lineNumber:(l=r.trace[0])!=null&&l.lineNumber?r.trace[0].lineNumber:0,columnNumber:(u=r.trace[0])!=null&&u.columnNumber?r.trace[0].columnNumber:0,stackTrace:r.trace,timestamp:new Date().toISOString()})}else e.messages.push(r)},{level:this.consoleMethodsToRecord,logger:"console",stringifyOptions:{depthOfLimit:10,numOfKeysLimit:100,stringLengthLimit:1e3}})),this.listeners.push(Me(r=>e.errors.push(r))),A.setupNetworkListener(this,this.options)}stopListening(){this.listeners.forEach(e=>e()),this.listeners=[]}static setupNetworkListener(e,r){var o,l,u,s,i,n,c,a;e._backendUrl=(r==null?void 0:r.backendUrl)||Y||"https://pub.highlight.run",e.xhrNetworkContents=[],e.fetchNetworkContents=[],e.networkHeadersToRedact=[],e.urlBlocklist=[],e.tracingOrigins=r.tracingOrigins||[],(r==null?void 0:r.disableNetworkRecording)!==void 0?(e.disableNetworkRecording=r==null?void 0:r.disableNetworkRecording,e.enableRecordingNetworkContents=!1,e.networkHeadersToRedact=[],e.urlBlocklist=[],e.networkBodyKeysToRecord=[],e.networkBodyKeysToRecord=[]):typeof(r==null?void 0:r.networkRecording)=="boolean"?(e.disableNetworkRecording=!r.networkRecording,e.enableRecordingNetworkContents=!1,e.networkHeadersToRedact=[],e.urlBlocklist=[]):(((o=r.networkRecording)==null?void 0:o.enabled)!==void 0?e.disableNetworkRecording=!r.networkRecording.enabled:e.disableNetworkRecording=!1,e.enableRecordingNetworkContents=((l=r.networkRecording)==null?void 0:l.recordHeadersAndBody)||!1,e.networkHeadersToRedact=((s=(u=r.networkRecording)==null?void 0:u.networkHeadersToRedact)==null?void 0:s.map(d=>d.toLowerCase()))||[],e.urlBlocklist=((n=(i=r.networkRecording)==null?void 0:i.urlBlocklist)==null?void 0:n.map(d=>d.toLowerCase()))||[],e.urlBlocklist=[...e.urlBlocklist,...nt],e.networkHeaderKeysToRecord=(c=r.networkRecording)==null?void 0:c.headerKeysToRecord,e.networkHeaderKeysToRecord&&(e.networkHeadersToRedact=[],e.networkHeaderKeysToRecord=e.networkHeaderKeysToRecord.map(d=>d.toLocaleLowerCase())),e.networkBodyKeysToRecord=(a=r.networkRecording)==null?void 0:a.bodyKeysToRecord,e.networkBodyKeysToRecord&&(e.networkBodyKeysToRecord=e.networkBodyKeysToRecord.map(d=>d.toLocaleLowerCase()))),!e.disableNetworkRecording&&e.enableRecordingNetworkContents&&e.listeners.push(yt({xhrCallback:d=>{e.xhrNetworkContents.push(d)},fetchCallback:d=>{e.fetchNetworkContents.push(d)},headersToRedact:e.networkHeadersToRedact,backendUrl:e._backendUrl,tracingOrigins:e.tracingOrigins,urlBlocklist:e.urlBlocklist,sessionSecureID:r.sessionSecureID,headerKeysToRecord:e.networkHeaderKeysToRecord,bodyKeysToRecord:e.networkBodyKeysToRecord}))}static getRecordedNetworkResources(e,r){var o;let l=[];if(!e.disableNetworkRecording){const u=((o=window==null?void 0:window.performance)==null?void 0:o.timeOrigin)||0;l=performance.getEntriesByType("resource");const s=(r-u)*2;l=l.filter(i=>$(i.name,e._backendUrl,e.tracingOrigins)).map(i=>Nt(Et({},i.toJSON()),{offsetStartTime:i.startTime-s,offsetResponseEnd:i.responseEnd-s,offsetFetchStart:i.fetchStart-s})),e.enableRecordingNetworkContents&&(l=ee(l,e.xhrNetworkContents,"xmlhttprequest"),l=ee(l,e.fetchNetworkContents,"fetch"))}return l}static clearRecordedNetworkResources(e){e.disableNetworkRecording||(e.xhrNetworkContents=[],e.fetchNetworkContents=[],performance.clearResourceTimings())}}const _t=()=>{var t;const e="abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";var r="";const o=typeof window!="undefined"&&((t=window.crypto)==null?void 0:t.getRandomValues),l=new Uint32Array(28);o&&window.crypto.getRandomValues(l);for(let u=0;u<28;u++)o?r+=e.charAt(l[u]%e.length):r+=e.charAt(Math.floor(Math.random()*e.length));return r},Tt=({next:t,payload:e})=>{if(typeof window!="undefined"&&typeof document!="undefined"&&"H"in window){if(e.obj.type==="track"){const r=e.obj.event,o=e.obj.properties;window.H.track(r,o)}else if(e.obj.type==="identify"){const r=e.obj.userId;if(r!=null&&r.length){const o=e.obj.traits;window.H.identify(r,o)}}}t(e)};var xt=Tt,Lt=Object.defineProperty,It=Object.defineProperties,Ct=Object.getOwnPropertyDescriptors,he=Object.getOwnPropertySymbols,Ht=Object.prototype.hasOwnProperty,Pt=Object.prototype.propertyIsEnumerable,me=(t,e,r)=>e in t?Lt(t,e,{enumerable:!0,configurable:!0,writable:!0,value:r}):t[e]=r,E=(t,e)=>{for(var r in e||(e={}))Ht.call(e,r)&&me(t,r,e[r]);if(he)for(var r of he(e))Pt.call(e,r)&&me(t,r,e[r]);return t},N=(t,e)=>It(t,Ct(e));$e();var ve=(t=>(t.Device="Device",t.WebVital="WebVital",t.Frontend="Frontend",t.Backend="Backend",t))(ve||{});const R=(t,e)=>{console.warn(`Highlight Warning: (${t}): `,e)};var k,v,_,we=!1;const w={options:void 0,init:(t,e)=>{var r,o,l,u;try{if(w.options=e,typeof window=="undefined"||typeof document=="undefined")return;if(!t){console.info("Highlight is not initializing because projectID was passed undefined.");return}if(we)return;we=!0,k=document.createElement("script");var s=e!=null&&e.scriptUrl?e.scriptUrl:`https://static.highlight.io/v${q.version}/index.js`;k.setAttribute("src",s),k.setAttribute("type","text/javascript"),document.getElementsByTagName("head")[0].appendChild(k);let i=Ae(),n=_t();i!=null&&i.sessionSecureID&&(n=i.sessionSecureID);const c={organizationID:t,debug:e==null?void 0:e.debug,backendUrl:e==null?void 0:e.backendUrl,tracingOrigins:e==null?void 0:e.tracingOrigins,disableNetworkRecording:e==null?void 0:e.disableNetworkRecording,networkRecording:e==null?void 0:e.networkRecording,disableBackgroundRecording:e==null?void 0:e.disableBackgroundRecording,disableConsoleRecording:e==null?void 0:e.disableConsoleRecording,consoleMethodsToRecord:e==null?void 0:e.consoleMethodsToRecord,enableSegmentIntegration:e==null?void 0:e.enableSegmentIntegration,enableStrictPrivacy:e==null?void 0:e.enableStrictPrivacy,enableCanvasRecording:e==null?void 0:e.enableCanvasRecording,enablePerformanceRecording:e==null?void 0:e.enablePerformanceRecording,samplingStrategy:e==null?void 0:e.samplingStrategy,inlineImages:e==null?void 0:e.inlineImages,inlineStylesheet:e==null?void 0:e.inlineStylesheet,isCrossOriginIframe:e==null?void 0:e.isCrossOriginIframe,firstloadVersion:q.version,environment:(e==null?void 0:e.environment)||"production",appVersion:e==null?void 0:e.version,sessionShortcut:e==null?void 0:e.sessionShortcut,feedbackWidget:e==null?void 0:e.feedbackWidget,sessionSecureID:n};_=new A(c),e!=null&&e.manualStart||_.startListening(),k.addEventListener("load",()=>{const a=()=>{v=new window.Highlight(c,_),e!=null&&e.manualStart||v.initialize()};if("Highlight"in window)a();else{const d=setInterval(()=>{"Highlight"in window&&(a(),clearInterval(d))},500)}}),(o=(r=e==null?void 0:e.integrations)==null?void 0:r.mixpanel)!=null&&o.projectToken&&He(e.integrations.mixpanel),(u=(l=e==null?void 0:e.integrations)==null?void 0:l.amplitude)!=null&&u.apiKey&&Ce(e.integrations.amplitude)}catch(i){R("init",i)}},addSessionFeedback:({verbatim:t,userName:e,userEmail:r,timestampOverride:o})=>{try{w.onHighlightReady(()=>v.addSessionFeedback({verbatim:t,timestamp:o||new Date().toISOString(),user_email:r,user_name:e}))}catch(l){R("error",l)}},toggleSessionFeedbackModal:()=>{try{w.onHighlightReady(()=>v.toggleFeedbackWidgetVisibility())}catch(t){R("error",t)}},consumeError:(t,e,r)=>{try{w.onHighlightReady(()=>v.consumeCustomError(t,e,JSON.stringify(r)))}catch(o){R("error",o)}},error:(t,e)=>{try{w.onHighlightReady(()=>v.pushCustomError(t,JSON.stringify(e)))}catch(r){R("error",r)}},track:(t,e={})=>{var r,o,l,u,s,i,n,c,a,d,p;try{w.onHighlightReady(()=>v.addProperties(N(E({},e),{event:t})));const h=v==null?void 0:v.getCurrentSessionURL();(l=(o=(r=w.options)==null?void 0:r.integrations)==null?void 0:o.mixpanel)!=null&&l.disabled||((u=window.mixpanel)!=null&&u.track?window.mixpanel.track(t,N(E({},e),{highlightSessionURL:h})):console.warn("Mixpanel not loaded, but Highlight is configured to use it. This is usually caused by Mixpanel being blocked by the user's browser.")),(n=(i=(s=w.options)==null?void 0:s.integrations)==null?void 0:i.amplitude)!=null&&n.disabled||(c=window.amplitude)!=null&&c.getInstance&&window.amplitude.getInstance().logEvent(t,N(E({},e),{highlightSessionURL:h})),(p=(d=(a=w.options)==null?void 0:a.integrations)==null?void 0:d.intercom)!=null&&p.disabled||window.Intercom&&window.Intercom("trackEvent",t,e)}catch(h){R("track",h)}},start:t=>{try{if((v==null?void 0:v.state)==="Recording"){t!=null&&t.silent||console.warn("You cannot called `start()` again. The session is already being recorded.");return}else{_.startListening();var e=setInterval(function(){v&&(clearInterval(e),v.initialize())},200)}}catch(r){R("start",r)}},stop:()=>{try{w.onHighlightReady(()=>v.stopRecording(!0))}catch(t){R("stop",t)}},identify:(t,e={})=>{var r,o,l,u,s,i,n,c;try{w.onHighlightReady(()=>v.identify(t,e))}catch(a){R("identify",a)}if((l=(o=(r=w.options)==null?void 0:r.integrations)==null?void 0:o.mixpanel)!=null&&l.disabled||(u=window.mixpanel)!=null&&u.identify&&window.mixpanel.identify(t),!((n=(i=(s=w.options)==null?void 0:s.integrations)==null?void 0:i.amplitude)!=null&&n.disabled)&&(c=window.amplitude)!=null&&c.getInstance&&(window.amplitude.getInstance().setUserId(t),Object.keys(e).length>0)){const a=Object.keys(e).reduce((d,p)=>(d.set(p,e[p]),d),new window.amplitude.Identify);window.amplitude.getInstance().identify(a)}},metrics:t=>{try{w.onHighlightReady(()=>v.recordMetric(t.map(e=>N(E({},e),{category:"Frontend"}))))}catch(e){R("metrics",e)}},getSessionURL:()=>new Promise((t,e)=>{w.onHighlightReady(()=>{const r=v.getCurrentSessionURL();r?t(r):e(new Error("Unable to get session URL"))})}),getSessionDetails:()=>new Promise((t,e)=>{w.onHighlightReady(()=>{const r=v.getCurrentSessionURL();if(r){const o=v.getCurrentSessionTimestamp(),l=new Date().getTime(),u=new URL(r),s=new URL(r);s.searchParams.set("ts",((l-o)/1e3).toString()),t({url:u.toString(),urlWithTimestamp:s.toString()})}else e(new Error("Could not get session URL"))})}),onHighlightReady:t=>{try{if(v&&v.ready)t();else var e=setInterval(function(){v&&v.ready&&(clearInterval(e),t())},200)}catch(r){R("onHighlightReady",r)}}};typeof window!="undefined"&&(window.H=w),Ie();
//# sourceMappingURL=indexESM.js.map

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./scripts/rudder-initialize.js
let rudderstackInitialized = false;
async function rudderInitialize() {
    if (rudderstackInitialized) {
        return;
    }
    rudderstackInitialized = true;
    window.rudderanalytics = await __webpack_require__.e(/* import() */ 1917).then(__webpack_require__.t.bind(__webpack_require__, 23067, 23));
    rudderanalytics.load("2HMp4bSqggu0Z8W1cn6G5nydUxg", "https://highlightwjh.dataplane.rudderstack.com", {
        integrations: {
            All: true
        }
    });
    rudderanalytics.ready(()=>{
        console.log("Rudderstack initialized!");
    });
}

;// CONCATENATED MODULE: ./node_modules/@react-aria/ssr/dist/module.js



// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $704cf1d3b684cc5c$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $704cf1d3b684cc5c$var$SSRContext = /*#__PURE__*/ react.createContext($704cf1d3b684cc5c$var$defaultContext);
function $704cf1d3b684cc5c$export$9f8ac96af4b1b2ae(props) {
    let cur = (0,react.useContext)($704cf1d3b684cc5c$var$SSRContext);
    let value = (0,react.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $704cf1d3b684cc5c$var$defaultContext ? '' : `${cur.prefix}-${++cur.current}`,
            current: 0
        })
    , [
        cur
    ]);
    return(/*#__PURE__*/ react.createElement($704cf1d3b684cc5c$var$SSRContext.Provider, {
        value: value
    }, props.children));
}
let $704cf1d3b684cc5c$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
function $704cf1d3b684cc5c$export$619500959fc48b26(defaultId) {
    let ctx = $89yE2$useContext($704cf1d3b684cc5c$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    if (ctx === $704cf1d3b684cc5c$var$defaultContext && !$704cf1d3b684cc5c$var$canUseDOM) console.warn('When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.');
    return $89yE2$useMemo(()=>defaultId || `react-aria${ctx.prefix}-${++ctx.current}`
    , [
        defaultId
    ]);
}
function $704cf1d3b684cc5c$export$535bd6ca7f90a273() {
    let cur = $89yE2$useContext($704cf1d3b684cc5c$var$SSRContext);
    let isInSSRContext = cur !== $704cf1d3b684cc5c$var$defaultContext;
    let [isSSR, setIsSSR] = $89yE2$useState(isInSSRContext);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof window !== 'undefined' && isInSSRContext) // This if statement technically breaks the rules of hooks, but is safe
    // because the condition never changes after mounting.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $89yE2$useLayoutEffect(()=>{
        setIsSSR(false);
    }, []);
    return isSSR;
}





//# sourceMappingURL=module.js.map

;// CONCATENATED MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
/*! js-cookie v3.0.1 | MIT */
/* eslint-disable no-var */
function js_cookie_assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (key, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = js_cookie_assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    key = encodeURIComponent(key)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      key + '=' + converter.write(value, key) + stringifiedAttributes)
  }

  function get (key) {
    if (typeof document === 'undefined' || (arguments.length && !key)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var foundKey = decodeURIComponent(parts[0]);
        jar[foundKey] = converter.read(value, foundKey);

        if (key === foundKey) {
          break
        }
      } catch (e) {}
    }

    return key ? jar[key] : jar
  }

  return Object.create(
    {
      set: set,
      get: get,
      remove: function (key, attributes) {
        set(
          key,
          '',
          js_cookie_assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, js_cookie_assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(js_cookie_assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });
/* eslint-enable no-var */

/* harmony default export */ var js_cookie = (api);

;// CONCATENATED MODULE: ./utils/attribution.ts

// Same as what we have in frontend. Need to keep these in sync.
const setAttributionData = ()=>{
    let referrer = {};
    const prevRef = js_cookie.get("referrer");
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("utm_source")) {
        referrer = {
            utm_source: urlParams.get("utm_source"),
            utm_medium: urlParams.get("utm_medium"),
            utm_campaign: urlParams.get("utm_campaign"),
            utm_content: urlParams.get("utm_content"),
            utm_term: urlParams.get("utm_term"),
            device: urlParams.get("device"),
            gclid: urlParams.get("gclid"),
            referrer: urlParams.get("ref")
        };
    } else if (prevRef) {
        referrer = JSON.parse(prevRef);
    }
    referrer.documentReferrer = document.referrer;
    js_cookie.set("referrer", JSON.stringify(referrer), {
        domain: "highlight.io"
    });
};

;// CONCATENATED MODULE: ./pages/_app.tsx















router_default().events.on("routeChangeStart", (nprogress_default()).start);
router_default().events.on("routeChangeError", (nprogress_default()).done);
router_default().events.on("routeChangeComplete", ()=>{
    if (window.rudderanalytics) {
        var ref;
        (ref = window.rudderanalytics) === null || ref === void 0 ? void 0 : ref.page();
    }
    nprogress_default().done();
});
w.init("4d7k1xeo", {
    networkRecording: {
        enabled: true,
        recordHeadersAndBody: true
    },
    tracingOrigins: true
});
function MyApp(param) {
    let { Component , pageProps  } = param;
    (0,react.useEffect)(()=>{
        const initialize = async ()=>{
            var ref, ref1;
            setAttributionData();
            await rudderInitialize();
            (ref = window.rudderanalytics) === null || ref === void 0 ? void 0 : ref.page();
            (ref1 = window.rudderanalytics) === null || ref1 === void 0 ? void 0 : ref1.identify();
        };
        initialize();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)($704cf1d3b684cc5c$export$9f8ac96af4b1b2ae, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "highlight.io: The open source monitoring platform."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.ico"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* Meta */.h, {
                title: "highlight.io: The open source monitoring platform.",
                description: "highlight.io is the open source monitoring platform that gives you the visibility you need.",
                absoluteImageUrl: "https://".concat("highlight-landing-k3brijlsv-highlight-run.vercel.app").concat(meta_image/* default.src */.Z.src)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
                ...pageProps
            })
        ]
    });
}
/* harmony default export */ var _app = (MyApp);


/***/ }),

/***/ 48339:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 61348:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 62834:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(83121)


/***/ }),

/***/ 11163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(80880)


/***/ }),

/***/ 74865:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* NProgress, (c) 2013, 2014 Rico Sta. Cruz - http://ricostacruz.com/nprogress
 * @license MIT */

;(function(root, factory) {

  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}

})(this, function() {
  var NProgress = {};

  NProgress.version = '0.2.0';

  var Settings = NProgress.settings = {
    minimum: 0.08,
    easing: 'ease',
    positionUsing: '',
    speed: 200,
    trickle: true,
    trickleRate: 0.02,
    trickleSpeed: 800,
    showSpinner: true,
    barSelector: '[role="bar"]',
    spinnerSelector: '[role="spinner"]',
    parent: 'body',
    template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
  };

  /**
   * Updates configuration.
   *
   *     NProgress.configure({
   *       minimum: 0.1
   *     });
   */
  NProgress.configure = function(options) {
    var key, value;
    for (key in options) {
      value = options[key];
      if (value !== undefined && options.hasOwnProperty(key)) Settings[key] = value;
    }

    return this;
  };

  /**
   * Last number.
   */

  NProgress.status = null;

  /**
   * Sets the progress bar status, where `n` is a number from `0.0` to `1.0`.
   *
   *     NProgress.set(0.4);
   *     NProgress.set(1.0);
   */

  NProgress.set = function(n) {
    var started = NProgress.isStarted();

    n = clamp(n, Settings.minimum, 1);
    NProgress.status = (n === 1 ? null : n);

    var progress = NProgress.render(!started),
        bar      = progress.querySelector(Settings.barSelector),
        speed    = Settings.speed,
        ease     = Settings.easing;

    progress.offsetWidth; /* Repaint */

    queue(function(next) {
      // Set positionUsing if it hasn't already been set
      if (Settings.positionUsing === '') Settings.positionUsing = NProgress.getPositioningCSS();

      // Add transition
      css(bar, barPositionCSS(n, speed, ease));

      if (n === 1) {
        // Fade out
        css(progress, { 
          transition: 'none', 
          opacity: 1 
        });
        progress.offsetWidth; /* Repaint */

        setTimeout(function() {
          css(progress, { 
            transition: 'all ' + speed + 'ms linear', 
            opacity: 0 
          });
          setTimeout(function() {
            NProgress.remove();
            next();
          }, speed);
        }, speed);
      } else {
        setTimeout(next, speed);
      }
    });

    return this;
  };

  NProgress.isStarted = function() {
    return typeof NProgress.status === 'number';
  };

  /**
   * Shows the progress bar.
   * This is the same as setting the status to 0%, except that it doesn't go backwards.
   *
   *     NProgress.start();
   *
   */
  NProgress.start = function() {
    if (!NProgress.status) NProgress.set(0);

    var work = function() {
      setTimeout(function() {
        if (!NProgress.status) return;
        NProgress.trickle();
        work();
      }, Settings.trickleSpeed);
    };

    if (Settings.trickle) work();

    return this;
  };

  /**
   * Hides the progress bar.
   * This is the *sort of* the same as setting the status to 100%, with the
   * difference being `done()` makes some placebo effect of some realistic motion.
   *
   *     NProgress.done();
   *
   * If `true` is passed, it will show the progress bar even if its hidden.
   *
   *     NProgress.done(true);
   */

  NProgress.done = function(force) {
    if (!force && !NProgress.status) return this;

    return NProgress.inc(0.3 + 0.5 * Math.random()).set(1);
  };

  /**
   * Increments by a random amount.
   */

  NProgress.inc = function(amount) {
    var n = NProgress.status;

    if (!n) {
      return NProgress.start();
    } else {
      if (typeof amount !== 'number') {
        amount = (1 - n) * clamp(Math.random() * n, 0.1, 0.95);
      }

      n = clamp(n + amount, 0, 0.994);
      return NProgress.set(n);
    }
  };

  NProgress.trickle = function() {
    return NProgress.inc(Math.random() * Settings.trickleRate);
  };

  /**
   * Waits for all supplied jQuery promises and
   * increases the progress as the promises resolve.
   *
   * @param $promise jQUery Promise
   */
  (function() {
    var initial = 0, current = 0;

    NProgress.promise = function($promise) {
      if (!$promise || $promise.state() === "resolved") {
        return this;
      }

      if (current === 0) {
        NProgress.start();
      }

      initial++;
      current++;

      $promise.always(function() {
        current--;
        if (current === 0) {
            initial = 0;
            NProgress.done();
        } else {
            NProgress.set((initial - current) / initial);
        }
      });

      return this;
    };

  })();

  /**
   * (Internal) renders the progress bar markup based on the `template`
   * setting.
   */

  NProgress.render = function(fromStart) {
    if (NProgress.isRendered()) return document.getElementById('nprogress');

    addClass(document.documentElement, 'nprogress-busy');
    
    var progress = document.createElement('div');
    progress.id = 'nprogress';
    progress.innerHTML = Settings.template;

    var bar      = progress.querySelector(Settings.barSelector),
        perc     = fromStart ? '-100' : toBarPerc(NProgress.status || 0),
        parent   = document.querySelector(Settings.parent),
        spinner;
    
    css(bar, {
      transition: 'all 0 linear',
      transform: 'translate3d(' + perc + '%,0,0)'
    });

    if (!Settings.showSpinner) {
      spinner = progress.querySelector(Settings.spinnerSelector);
      spinner && removeElement(spinner);
    }

    if (parent != document.body) {
      addClass(parent, 'nprogress-custom-parent');
    }

    parent.appendChild(progress);
    return progress;
  };

  /**
   * Removes the element. Opposite of render().
   */

  NProgress.remove = function() {
    removeClass(document.documentElement, 'nprogress-busy');
    removeClass(document.querySelector(Settings.parent), 'nprogress-custom-parent');
    var progress = document.getElementById('nprogress');
    progress && removeElement(progress);
  };

  /**
   * Checks if the progress bar is rendered.
   */

  NProgress.isRendered = function() {
    return !!document.getElementById('nprogress');
  };

  /**
   * Determine which positioning CSS rule to use.
   */

  NProgress.getPositioningCSS = function() {
    // Sniff on document.body.style
    var bodyStyle = document.body.style;

    // Sniff prefixes
    var vendorPrefix = ('WebkitTransform' in bodyStyle) ? 'Webkit' :
                       ('MozTransform' in bodyStyle) ? 'Moz' :
                       ('msTransform' in bodyStyle) ? 'ms' :
                       ('OTransform' in bodyStyle) ? 'O' : '';

    if (vendorPrefix + 'Perspective' in bodyStyle) {
      // Modern browsers with 3D support, e.g. Webkit, IE10
      return 'translate3d';
    } else if (vendorPrefix + 'Transform' in bodyStyle) {
      // Browsers without 3D support, e.g. IE9
      return 'translate';
    } else {
      // Browsers without translate() support, e.g. IE7-8
      return 'margin';
    }
  };

  /**
   * Helpers
   */

  function clamp(n, min, max) {
    if (n < min) return min;
    if (n > max) return max;
    return n;
  }

  /**
   * (Internal) converts a percentage (`0..1`) to a bar translateX
   * percentage (`-100%..0%`).
   */

  function toBarPerc(n) {
    return (-1 + n) * 100;
  }


  /**
   * (Internal) returns the correct CSS for changing the bar's
   * position given an n percentage, and speed and ease from Settings
   */

  function barPositionCSS(n, speed, ease) {
    var barCSS;

    if (Settings.positionUsing === 'translate3d') {
      barCSS = { transform: 'translate3d('+toBarPerc(n)+'%,0,0)' };
    } else if (Settings.positionUsing === 'translate') {
      barCSS = { transform: 'translate('+toBarPerc(n)+'%,0)' };
    } else {
      barCSS = { 'margin-left': toBarPerc(n)+'%' };
    }

    barCSS.transition = 'all '+speed+'ms '+ease;

    return barCSS;
  }

  /**
   * (Internal) Queues a function to be executed.
   */

  var queue = (function() {
    var pending = [];
    
    function next() {
      var fn = pending.shift();
      if (fn) {
        fn(next);
      }
    }

    return function(fn) {
      pending.push(fn);
      if (pending.length == 1) next();
    };
  })();

  /**
   * (Internal) Applies css properties to an element, similar to the jQuery 
   * css method.
   *
   * While this helper does assist with vendor prefixed property names, it 
   * does not perform any manipulation of values prior to setting styles.
   */

  var css = (function() {
    var cssPrefixes = [ 'Webkit', 'O', 'Moz', 'ms' ],
        cssProps    = {};

    function camelCase(string) {
      return string.replace(/^-ms-/, 'ms-').replace(/-([\da-z])/gi, function(match, letter) {
        return letter.toUpperCase();
      });
    }

    function getVendorProp(name) {
      var style = document.body.style;
      if (name in style) return name;

      var i = cssPrefixes.length,
          capName = name.charAt(0).toUpperCase() + name.slice(1),
          vendorName;
      while (i--) {
        vendorName = cssPrefixes[i] + capName;
        if (vendorName in style) return vendorName;
      }

      return name;
    }

    function getStyleProp(name) {
      name = camelCase(name);
      return cssProps[name] || (cssProps[name] = getVendorProp(name));
    }

    function applyCss(element, prop, value) {
      prop = getStyleProp(prop);
      element.style[prop] = value;
    }

    return function(element, properties) {
      var args = arguments,
          prop, 
          value;

      if (args.length == 2) {
        for (prop in properties) {
          value = properties[prop];
          if (value !== undefined && properties.hasOwnProperty(prop)) applyCss(element, prop, value);
        }
      } else {
        applyCss(element, args[1], args[2]);
      }
    }
  })();

  /**
   * (Internal) Determines if an element or space separated list of class names contains a class name.
   */

  function hasClass(element, name) {
    var list = typeof element == 'string' ? element : classList(element);
    return list.indexOf(' ' + name + ' ') >= 0;
  }

  /**
   * (Internal) Adds a class to an element.
   */

  function addClass(element, name) {
    var oldList = classList(element),
        newList = oldList + name;

    if (hasClass(oldList, name)) return; 

    // Trim the opening space.
    element.className = newList.substring(1);
  }

  /**
   * (Internal) Removes a class from an element.
   */

  function removeClass(element, name) {
    var oldList = classList(element),
        newList;

    if (!hasClass(element, name)) return;

    // Replace the class name.
    newList = oldList.replace(' ' + name + ' ', ' ');

    // Trim the opening and closing spaces.
    element.className = newList.substring(1, newList.length - 1);
  }

  /**
   * (Internal) Gets a space separated list of the class names on the element. 
   * The list is wrapped with a single space on each end to facilitate finding 
   * matches within the list.
   */

  function classList(element) {
    return (' ' + (element.className || '') + ' ').replace(/\s+/gi, ' ');
  }

  /**
   * (Internal) Removes an element from the DOM.
   */

  function removeElement(element) {
    element && element.parentNode && element.parentNode.removeChild(element);
  }

  return NProgress;
});



/***/ }),

/***/ 34155:
/***/ (function(module) {

// shim for using process in browser

var process = module.exports = {};
var queue = [];
var draining = false;

function drainQueue() {
    if (draining) {
        return;
    }
    draining = true;
    var currentQueue;
    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        var i = -1;
        while (++i < len) {
            currentQueue[i]();
        }
        len = queue.length;
    }
    draining = false;
}
process.nextTick = function (fun) {
    queue.push(fun);
    if (!draining) {
        setTimeout(drainQueue, 0);
    }
};

process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

// TODO(shtylman)
process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(6840), __webpack_exec__(80880); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);